import * as React from 'react'
import { createComponent } from '@cloudflare/style-container'
export type TFlexPassthroughProps = { direction?: 'row' | 'column' }
export const FlexPassthroughRule = ({
  direction = 'row',
}: TFlexPassthroughProps) => ({
  display: 'flex',
  flexDirection: direction,
  flex: 1,
})
export const FlexPassthrough = createComponent(FlexPassthroughRule)



// WEBPACK FOOTER //
// ./node_modules/@cloudflare/cf-component-flex-passthrough/src/index.tsx